<template>
  <div class="editTime">
    <el-button type="primary" plain @click="editTimeClick">修改</el-button>
    <el-dialog
      width="600px !important"
      title="修改审核时间"
      :visible.sync="dialogVisible"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="90px">
        <el-form-item label="审核时间" prop="auditTime">
          <el-date-picker
            v-model="form.auditTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择审核日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <div class="submitArea">
          <el-button type="primary" @click="auditSubmit()">提交</el-button>
          <el-button plain @click="dialogVisible = false">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getAuditTime } from "@/api/feedback";
export default {
  name: "editTime",
  props: {
    taskId: {
      type: String,
      default: "",
    },
  },
  inject: ["loadTaskDetail"],
  data() {
    return {
      dialogVisible: false,
      form: {
        auditTime: "",
      },
      rules: {
        auditTime: [
          {
            required: true,
            message: "审核时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    editTimeClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form?.resetFields();
      });
    },
    auditSubmit() {
      this.$refs["form"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let params = {
          taskId: this.taskId,
          auditTime: this.form.auditTime,
        };
        getAuditTime(params).then((res) => {
          if (res.status == "0") {
            this.loadTaskDetail();
            this.$DonMessage.success("审核时间修改成功!");
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.editTime {
  line-height: 1.5;
}
.editTime > .el-button {
  margin-left: 10px;
  padding: 2px 4px !important;
}
</style>
